import { render } from "./AdTypeList.vue?vue&type=template&id=c5a3d3b6"
import script from "./AdTypeList.vue?vue&type=script&lang=js"
export * from "./AdTypeList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__